import { render } from "./Pagination.vue?vue&type=template&id=3fc62e7d&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=3fc62e7d&scoped=true&lang=css"

import exportComponent from "F:\\.openserver\\OpenServer\\domains\\geo_exams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc62e7d"]])

export default __exports__